// src/utils/clearCache.js
import axios from 'axios'

/**
 * 清除缓存工具类（自动执行版）
 * 包含：1. 清除接口缓存 2. 清除样式缓存 3. 防抖逻辑
 */
export const clearCache = {
  // 防抖标记，避免重复执行
  isCleared: false,

  /**
   * 清除axios请求缓存
   */
  clearApiCache() {
    try {
      // 1. 取消所有未完成的axios请求
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      source.cancel('初始化清除接口缓存，取消未完成请求')

      // 2. 禁用axios缓存相关配置
      axios.defaults.cache = false
      axios.defaults.headers.common['Cache-Control'] = 'no-cache'
      axios.defaults.headers.common['Pragma'] = 'no-cache'
      axios.defaults.headers.common['Expires'] = '0'

      console.log('✅ 接口缓存自动清除完成')
    } catch (error) {
      console.error('❌ 清除接口缓存失败：', error)
    }
  },

  /**
   * 清除样式缓存
   */
  clearStyleCache() {
    try {
      const links = document.querySelectorAll('link[rel="stylesheet"]')
      links.forEach(link => {
        const originalHref = link.href
        if (originalHref && !originalHref.includes('?t=')) { // 避免重复添加时间戳
          const cleanHref = originalHref.split('?')[0]
          const newHref = `${cleanHref}?t=${new Date().getTime()}`
          
          const newLink = document.createElement('link')
          newLink.rel = 'stylesheet'
          newLink.href = newHref
          newLink.onload = () => {
            link.parentNode?.removeChild(link)
          }
          link.parentNode?.insertBefore(newLink, link)
        }
      })
      console.log('✅ 样式缓存自动清除完成')
    } catch (error) {
      console.error('❌ 清除样式缓存失败：', error)
    }
  },

  /**
   * 一键清除所有缓存（带防抖）
   */
  clearAllCache() {
    // 防抖：确保只执行一次
    if (this.isCleared) return
    this.isCleared = true

    this.clearApiCache()
    this.clearStyleCache()
    
    // 可选：清除localStorage/sessionStorage
    // localStorage.clear()
    // sessionStorage.clear()

    console.log('✅ 所有缓存自动清除完成（全局生效）')
  },

  /**
   * 路由切换时清除缓存（可选）
   */
  clearCacheOnRouteChange() {
    // 重置防抖标记
    this.isCleared = false
    // 轻量清除：只刷新接口缓存，避免样式频繁重载导致闪烁
    this.clearApiCache()
    console.log('✅ 路由切换，接口缓存已清除')
  }
}